import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import { useAuthDetailStore } from "../stores/useAuthStore";
import {
    function_expenses,
    function_telework,
    function_timereporting,
} from "../utils/feature_access";

export const FEATURES_KEYS = {
    EXPENSES: "expenses",
    TIME_REPORTING: "time_reporting",
    TELEWORK: "telework",
};

const callback_key = {
    [FEATURES_KEYS.EXPENSES]: function_expenses,
    [FEATURES_KEYS.TIME_REPORTING]: function_timereporting,
    [FEATURES_KEYS.TELEWORK]: function_telework,
};

const withFeatureAccess = (WrappedComponent, key) => {
    // eslint-disable-next-line react/display-name
    return (props) => {
        const detail = useAuthDetailStore((state) => state.detail);
        const location = useLocation();
        // on vérifie si authenrtificated user est connecté ou pas, sinon logout.
        // peut etre il a supprime le storage.
        if (!detail) {
            return <Navigate to={ROUTES.login} />;
        }

        const response = callback_key[key]({ detail, location });
        if (!response.activated) {
            return <Navigate to={response.to} state={response.state} replace />;
        }

        return <WrappedComponent {...props} />;
    };
};

export default withFeatureAccess;
